import { Loader, Stack, Title, Text } from '@mantine/core';
import { Statement } from 'interfaces';
import { StatementCard } from './StatementCard';
import { compareDateDesc } from 'utils/dateUtils';

interface StatementCardProps {
  data: Statement[];
  isLoading: boolean;
}

export const StatementCards: React.FC<StatementCardProps> = ({
  data,
  isLoading,
}) => {
  data.sort((a, b) => compareDateDesc(a.startDate, b.startDate));
  return (
    <Stack gap="md">
      <Title pl={'md'} mt={'sm'} order={3}>
        Statements
      </Title>
      {isLoading ? (
        <Loader
          size={'xl'}
          display={'flex'}
          style={{
            justifyContent: 'center',
            height: '90vh',
            alignItems: 'center',
            width: '100%',
          }}
        />
      ) : (
        <>
          {data.length ? (
            data.map((statement: Statement) => (
              <StatementCard
                statement={statement}
                loadingStatements={isLoading}
                key={statement.id}
              />
            ))
          ) : (
            <Text pl={'md'} mt={'sm'}>
              No statements found
            </Text>
          )}
        </>
      )}
    </Stack>
  );
};
